import Sheet from 'components/sheet';
import { usePetContext } from 'contexts/pet';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface PropTypes {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal used on Dogs and Cats landingpages to show information about the company.
 */
const AboutUsModal: React.FC<PropTypes> = ({ isOpen, onClose }) => {
  const { current } = usePetContext();

  return (
    <>
      <Sheet isOpen={isOpen} onClose={onClose}>
        <div className="my-4 flex flex-col gap-8 px-4">
          <p className="text-xl font-black leading-tight">
            <FormattedMessage id="landingpage:about-us-modal:headline" />
          </p>
          <p>
            <FormattedMessage
              id="landingpage:about-us-modal:section:1"
              values={{
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
          </p>
          <p>
            <FormattedMessage
              id="landingpage:about-us-modal:section:2"
              values={{
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
          </p>
          <p>
            <FormattedMessage
              id={`landingpage:about-us-modal:section:3:${current}`}
              values={{
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
          </p>
        </div>
      </Sheet>
    </>
  );
};

export default AboutUsModal;
